<script>
import { stringify } from 'qs';
import datatableFormater from './datatable-formater';

export default {
  props: {
    formatedRequest: Boolean,
    loading: Boolean,
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    search: {
      type: Object,
      default: () => ({}),
    },
    fetch: {
      type: Function,
      // eslint-disable-next-line
        default: () => console.log('default fetch function')
    },
    updateTimeout: {
      type: Number,
      default: 500,
    },
  },
  data: () => ({
    draw: 0,
    totalItemsCount: 0,
    error: null,
    innerLoading: false,
  }),
  computed: {
    mutableOptions: {
      get() {
        return this.options;
      },
      set(val) {
        this.$emit('update:options', val);
      },
    },
    mutableItems: {
      get() {
        return this.items;
      },
      set(val) {
        this.$emit('update:items', val);
      },
    },
    mutableLoading: {
      get() {
        return this.loading && this.innerLoading;
      },
      set(val) {
        this.innerLoading = val;
        this.$emit('update:loading', val);
      },
    },
  },
  watch: {
    search: {
      deep: true,
      handler() {
        if (this.mutableOptions.page !== 1) {
          this.mutableOptions = {
            ...this.mutableOptions,
            page: 1,
          };
        } else {
          this.debouncedFetch(this.updateTimeout);
        }
      },
    },
    loading: {
      deep: true,
      handler(val) {
        this.mutableLoading = val;
      },
    },
    headers: {
      deep: true,
      handler() {
        this.debouncedFetch();
      },
    },
    options: {
      deep: true,
      handler() {
        this.debouncedFetch();
      },
    },
    AddedRequestParams: {
      deep: true,
      handler() {
        this.debouncedFetch();
      },
    },
  },
  created() {
    this.debouncedFetch();
  },
  methods: {
    debouncedFetch(ms = 0) {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.innerFetch, ms);
    },
    innerFetch() {
      this.$emit('request')

      let requestBody = {
        headers: this.headers,
        options: this.options,
        search: this.search,
        draw: this.draw,
      };

      if (this.formatedRequest) {
        requestBody = stringify(datatableFormater(requestBody));
      }

      this.mutableLoading = true;
      this.fetch(requestBody)
        .then(({
          items,
          totalItemsCount,
        }) => {
          this.draw += 1;
          this.mutableItems = items;
          this.totalItemsCount = totalItemsCount;
          this.mutableLoading = false;
        })
        .catch((error) => {
          if (error.message === 'new request') {
            return
          }
          this.mutableLoading = false;
          this.error = error;
        })
    },
  },
  render() {
    return this.$scopedSlots.default({
      items: this.mutableItems,
      headers: this.headers,
      options: this.options,
      search: this.search,
      loading: this.innerLoading,
      totalItemsCount: this.totalItemsCount,
      error: this.error,
      fetch: this.innerFetch
    });
  },
};
</script>
